import React, { Component } from 'react';
import { map } from 'lodash';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {getUser} from "../../store/actions/user";
import {getCuisines} from "../../store/actions/cuisine";
import {getFoodCategories} from "../../store/actions/foodCategories";


class SingleUser extends Component {
    componentDidMount(){
        const id= this.props.match.params.id;
        const token = this.props.auth.token;
        this.props.getUser(token, id)
        this.props.getCuisines(token)
        this.props.getFoodCategories(token)
    }
    render () {
        const cuisine =[];
        const foodCategorie=[];
        const user= this.props.users;
        const cuisines = Object.values(this.props.cuisines);
        const foodCategories=Object.values(this.props.foodCategories);
        const foodCategorieId=map(this.props.users.food_categories, data=>data);
        const cuisineId=map(this.props.users.cuisines, data=>data);
        cuisineId.map(id => ( cuisines.map(
                data => {
                    if (data.id===id){
                        return cuisine.push(data.name)
                         }
                         return 0
                    }
                 )
        ));
        foodCategorieId.map(id => ( foodCategories.map(
                data => {
                    if (data.id===id){
                        return foodCategorie.push(data.name)
                    }
                    return 0
                }
            )
        ));
        return (
        <React.Fragment>
            <div className="page-title">
                <div className="container">
                    <div className="row flex-center-y justify-between">
                        <div className="col-xs-12 text-center">
                            <h1 className="color-grey capitalize">Single User</h1>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                {/* START: Breadcrumb Component */}
                <ul className="breadcrumb">
                    <li><Link to='/user-relationship/users'>User Management</Link></li>
                    <li>Single User</li>
                </ul>
                {/* END: Breadcrumb Component */}
            </div>

            <div className="container box inner-padding mb-15">
                <div className="box-body">
                    <div className="row justify-between">
                        <div className="col-xs-6 pr-70">
                            <ul className="w-700">
                                <li className="py-15">
                                    <p className="font-sm color-grey50">User First Name</p>
                                    <p className="color-primary mt-5">{user.first_name}</p>
                                </li>
                                <li className="py-15">
                                    <p className="font-sm color-grey50">User Last Name</p>
                                    <p className="color-primary mt-5">{user.last_name}</p>
                                </li>
                                <li className="py-15">
                                    <p className="font-sm color-grey50">User Mobile Number</p>
                                    <p className="color-primary mt-5">{user.mobile_number}</p>
                                </li>
                                <li className="py-15">
                                    <p className="font-sm color-grey50">Email</p>
                                    <p className="color-primary mt-5">{user.email}</p>
                                </li>
                                <li className="py-15">
                                    <p className="color-primary font-md w-700">Food Preferences</p>
                                    <div className="py-15">
                                        <p className="color-grey50 font-sm w-700 pb-10">Cuisine</p>
                                        {
                                            cuisine.map(data =>
                                                <ul key={data} className="column-3">
                                                    <li className="mb-5">{data}</li>
                                                </ul>
                                            )
                                        }
                                    </div>
                                    <div className="pt-15">
                                        <p className="color-grey50 font-sm w-700 pb-10">Food Category</p>
                                        {
                                            foodCategorie.map(data=>
                                                <ul key={data} className="column-3">
                                                    <li className="mb-5">{data}</li>
                                                </ul>
                                            )
                                        }
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="col-xs-6 pl-70">
                            <ul className="w-700">

                                <li className="py-15">
                                    <p className="font-sm color-grey50">Total Number of Login</p>
                                    <p className="color-primary mt-5">{user.login_count}</p>
                                </li>
                                <li className="py-15">
                                    <p className="font-sm color-grey50">Total Number of Orders</p>
                                    <p className="color-primary mt-5">{user.total_number_of_orders}</p>
                                </li>
                                <li className="py-15">
                                    <p className="font-sm color-grey50">Total Number of Referred Friends</p>
                                    <p className="color-primary mt-5">{user.referred_friends_count}</p>
                                </li>
                                <li className="py-15">
                                    <p className="font-sm color-grey50">Referred User</p>
                                    <p className="color-primary mt-5">Yes</p>
                                </li>
                                <li className="py-15">
                                    <p className="font-sm color-grey50">User Activities</p>
                                    <Link className="display-block mt-5 underline" to='/user-relationship/users/id/ratings'> Ratings </Link>
                                    <Link className="display-block mt-5 underline" to='#'> Live Chat </Link>
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>

        )
    }
}

function mapStateToProps(state){
    return {
        users: state.users,
        auth: state.auth,
        cuisines: state.cuisines,
        foodCategories: state.foodCategories
    }
}

export default connect(mapStateToProps, {getUser, getCuisines, getFoodCategories})(SingleUser);




// WEBPACK FOOTER //
// ./src/components/User-relationship/SingleUser.js